import React from 'react';
import { Spin } from 'antd';
import { RotationItem } from './rotations-row.component';
import { useRotationsContext } from '../rotations-context';
import { ListItemsNavigator } from 'src/components/common/items-navigator';
import styles from './rotations-list.module.scss';

const RotationsList = ({ rotations }) => {
  const { lang, loadingRotationsList } = useRotationsContext();

  if (loadingRotationsList) {
    return <Spin />;
  }

  if (!rotations?.length) {
    return null;
  }

  return (
    <ListItemsNavigator className={styles.list} aria-label={lang.ROTATIONS}>
      {rotations.map(item => (
        <RotationItem key={item.id} item={item} />
      ))}
    </ListItemsNavigator>
  );
};

export { RotationsList };
